import { render } from "./SelectArtwork.vue?vue&type=template&id=7e5f6f5a&lang=html"
import script from "./SelectArtwork.vue?vue&type=script&lang=js"
export * from "./SelectArtwork.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__